module.exports = __webpack_public_path__ + "img/数据库配置.dfe18900.svg";